var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_vm._v("Copyright © datacube co.,ltd. All Rights Reserved.")])}
var staticRenderFns = []

export { render, staticRenderFns }